export const stations = [
    {
        name: "Embajadores Stereo",
        id: "stream",
        link: "https://embajadoresdelgranrey.online/listen/embajadores_stereo/stream",
        status: true,
    },
    // {
    //     name: "Embajadores Valletanto",
    //     id: "vallenato",
    //     link: "https://embajadoresdelgranrey.online/listen/embajadores_stereo/vallenato",
    //     status: false,
    // },
    // {
    //     name: "Embajadores Gospel",
    //     id: "gospel",
    //     link: "https://embajadoresdelgranrey.online/listen/embajadores_stereo/gospel",
    //     status: false,
    // },
    // {
    //     name: "Embajadores Latino",
    //     id: "latino",
    //     link: "https://embajadoresdelgranrey.online/listen/embajadores_stereo/latino",
    //     status: false,
    // },
    // {
    //     name: "Embajadores Urbano",
    //     id: "urbano",
    //     link: "https://embajadoresdelgranrey.online/listen/embajadores_stereo/urbano",
    //     status: false,
    // }
];